import React from 'react';

const SolicitudesCompras = () => {
  return (
    <div className="container-fluid mt-4">
      <h1 className="mb-4">Solicitudes de Compras</h1>
      <div className="alert alert-info d-flex align-items-center gap-3 shadow-sm" role="alert">
        <i className="bi bi-tools fs-3"></i>
        <div>
          <strong>Sección en desarrollo</strong>
          <div className="small">
            La gestión de Solicitudes de Compra estará disponible en una próxima versión.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolicitudesCompras;
